import { SvgIcon } from '@mui/material';

const AnimalFeedIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <g
          clipPath="url(#a)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M1.953 15V5.876m13.094 0V15M1 7.418l2.821-4.56L8.5 1l4.679 1.859h0L16 7.419" />
          <path d="M10.32 3.936H6.68v3.23h3.64zM5.41 15V9.386h6.18V15M5.41 9.386 11.59 15m0-5.614L5.41 15M1 15h15" />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="currentColor" d="M.5 0h16v16H.5z" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default AnimalFeedIcon;
